var React = require('react');

function OpenInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29 23H23V29H21V23H15V21H21V15H23V21H29V23Z","fill":"#03A473","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"43","height":"43","rx":"21.5","stroke":"#03A473","key":1})]);
}

OpenInline.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = OpenInline;

OpenInline.default = OpenInline;
